import { combineLatest, Observable, of } from 'rxjs'
import { CanActivate, CanLoad, Route } from '@angular/router'
import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { catchError, map, switchMapTo, take, tap } from 'rxjs/operators'
import * as fromRoot from '@tv3/store/state'
import { IsDataLoaded } from '@tokeet-frontend/tv3-platform'
import { LoadAutomations } from './automation.actions'
import { selectAutomationsLoaded, selectAutomationsLoading } from './automation.selectors'

@Injectable()
export class AutomationGuard implements CanActivate, CanLoad, IsDataLoaded {
  constructor(private store: Store<fromRoot.State>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(select(selectAutomationsLoaded)),
      this.store.pipe(select(selectAutomationsLoading)),
    ]).pipe(
      tap(([isLoaded, isLoading]) => {
        if (!isLoaded && !isLoading) {
          this.store.dispatch(LoadAutomations({}))
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
